(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-split-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('.collection-split-showcase__nav');

    if (!button) {
      return;
    }

    var wrapper = button.closest('.collection-split-showcase__products-wrap');
    var scroller = wrapper && wrapper.querySelector('.collection-split-showcase__products');
    var product = scroller && scroller.querySelector('.collection-split-showcase__product');

    if (!scroller || !product) {
      return;
    }

    var gap = parseFloat(window.getComputedStyle(scroller).columnGap) || 0;
    var direction = parseInt(button.getAttribute('data-direction'), 10) || 1;
    var scrollDistance = product.getBoundingClientRect().width + gap;

    scroller.scrollBy({
      left: scrollDistance * direction,
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hover-video-steps"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('mouseover', function(event) {
    var card = event.target.closest('.hover-video-steps__media');

    if (!card || window.matchMedia('(max-width: 767px)').matches) {
      return;
    }

    var video = card.querySelector('video');

    if (video) {
      video.play();
    }
  });

  document.addEventListener('mouseout', function(event) {
    var card = event.target.closest('.hover-video-steps__media');

    if (!card || window.matchMedia('(max-width: 767px)').matches || card.contains(event.relatedTarget)) {
      return;
    }

    var video = card.querySelector('video');

    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-hover-video-play]');

    if (!button) {
      return;
    }

    var card = button.closest('.hover-video-steps__media');
    var video = card && card.querySelector('video');

    if (!video) {
      return;
    }

    if (video.paused) {
      video.play();
      card.classList.add('is-playing');
      button.setAttribute('aria-label', 'Pause video');
    } else {
      video.pause();
      card.classList.remove('is-playing');
      button.setAttribute('aria-label', 'Play video');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
